export default {
  OFFICE: 'office',
  OFFICE_ELEVATED: 'office_elevated',
  PSYCHOLOGIST: 'psychologist',
  SPD_MANAGER: 'spd_manager',
  VSA_MANAGER: 'vsa_manager',
  API_USER: 'api_user',
  CUSTOM: 'custom',
};
